export const ReceiptWizardSymbol = Symbol('ReceiptWizard')
